module.exports = __webpack_public_path__ + "static/media/portada.43c893d4.svg";